// TODO - @platform Fix the a11y violations flagged in the following disabled rules:

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* storybook-check-ignore */
import * as React from 'react';

import './NavigationBoxStyle.less';

export interface INavigationBoxLinkBase {
  active: boolean;
  text: string;
}

export type NavigationBoxLinkWithOnClick = INavigationBoxLinkBase & {
  onClick: () => void;
};

export type NavigationBoxLinkWithHref = INavigationBoxLinkBase & {
  href: string;
};

export type NavigationBoxLink = NavigationBoxLinkWithOnClick | NavigationBoxLinkWithHref;

export interface INavigationBoxProps {
  className?: string;
  links: Array<NavigationBoxLink>;
}

export default class NavigationBox extends React.PureComponent<INavigationBoxProps> {
  public shouldBeAnchorTag = (link: NavigationBoxLink): link is NavigationBoxLinkWithHref => {
    return (link as NavigationBoxLinkWithHref).href !== undefined;
  };

  public render() {
    const { className, links } = this.props;

    return (
      <div className={`od-navigation-box ${className || ''}`}>
        {links.map((link) => (
          <div
            className={`od-navigation-box-link-container ${link.active ? 'active' : ''}`}
            key={link.text}
          >
            {this.shouldBeAnchorTag(link) ? (
              <a className="od-navigation-box-link" href={link.href}>
                {link.text}
              </a>
            ) : (
              <span className="od-navigation-box-link" onClick={link.onClick}>
                {link.text}
              </span>
            )}
          </div>
        ))}
      </div>
    );
  }
}
